<template>
    <div class="card-body px-0 pt-0 pb-2">
        <div class="table-responsive transaction-table p-0">
            <table class="table main-table">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Reference number</th>
                        <th>Master Dealer</th>
                        <th>Dealer</th>
                        <th>Agent</th>
                        <th>Category of Billers</th>
                        <th>Name of Biller</th>
                        <th>Amount</th>
                        <th>Bayad Convenience</th>
                        <th>Total amount due</th>
                        <th>Standard Convenience</th>
                        <th>Total Paid</th>
                        <th v-if="isMasterDealer">SF Sharing</th>
                        <th v-if="isMasterDealer">Total SF Sharing</th>
                        <th v-if="isMasterDealer">Master Dealer Rate</th>
                        <th v-if="isMasterDealer">Dealer Rate</th>
                        <th v-if="isMasterDealer">Agent Rate</th>
                        <th v-if="isMasterDealer">Amt %Master Dealer</th>
                        <th>Amt %Dealer</th>
                        <th>Amt %Agent</th>
                        <th>Total wallet deducted Agent</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    <tr class="filter-background">
                        <td>
                            <Datepicker v-model="filters.dateRange" :enable-time-picker="false"
                                        class="form-control p-0 m-0 border" multi-calendars range />
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.referenceNumber" type="text" class="form-control"
                                       placeholder="Filter Reference" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.dealer" type="text" class="form-control"
                                       placeholder="Filter Dealer" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.retailer" type="text" class="form-control"
                                       placeholder="Filter Retailer" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.retailerUser" type="text" class="form-control"
                                       placeholder="Filter Retailer User" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.category" type="text" class="form-control"
                                       placeholder="Filter Category" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.billerName" type="text" class="form-control"
                                       placeholder="Filter Biller" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.amount" type="number" class="form-control"
                                       placeholder="Filter Amount" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.bayadConvenience" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.totalAmountDue" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.standardConvenience" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.totalPaid" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td v-if="isMasterDealer">
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.sfSharing" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td v-if="isMasterDealer">
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.totalSfSharing" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td v-if="isMasterDealer">
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.rateDealer" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td v-if="isMasterDealer">
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.rateRetailer" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td v-if="isMasterDealer">
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.rateRetailerUser" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td v-if="isMasterDealer">
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.amtDealer" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.amtRetailer" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.amtRetailerUser" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.totalWalletDeducted" type="number" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                        <td>
                            <div class="input-group">
                                <span class="input-group-text text-body">
                                    <img src="/img/filter.png" alt="logo" style="height: 0.6em;" />
                                </span>
                                <input v-model="filters.status" type="text" class="form-control"
                                       placeholder="Filter" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="loading">
                        <td :colspan="isMasterDealer ? 21 : 17">
                            <div class="text-center">
                                <Vue3Lottie :animationData="searchingJSON" class="height-150 py-2" />
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!loading && pageItems.length == 0">
                        <td :colspan="isMasterDealer ? 21 : 17">
                            <div class="text-center">
                                <Vue3Lottie :animationData="noDataJSON" class="height-150 py-2" />
                                <p class="text-xs font-weight-bold">No Data Found</p>
                            </div>
                        </td>
                    </tr>
                    <tr v-for="(transaction, index) in pageItems" :key="index">
                        <td>
                            {{ $format.FormatFullDateTime(transaction.date) }}
                        </td>
                        <td>
                            {{ transaction.referenceNumber }}
                        </td>
                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text">{{ transaction.dealer?.name }}</p>
                                <p class="sub-text">{{ transaction.dealer?.corporateID }}</p>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text">{{ transaction.retailer?.name }}</p>
                                <p class="sub-text">{{ transaction.retailer?.branch }}</p>
                            </div>
                        </td>
                        <td>
                            <div class="d-flex flex-column justify-content-center">
                                <p class="main-text">{{ transaction.retailerUser?.name }}</p>
                                <p class="sub-text">{{ transaction.retailerUser?.username }}</p>
                            </div>
                        </td>
                        <td>
                            {{ transaction.categoryOfBillers }}
                        </td>
                        <td>
                            {{ transaction.nameOfBiller }}
                        </td>
                        <td>
                            Php {{ transaction.amount?.toFixed(2) }}
                        </td>
                        <td>
                            Php {{ transaction.bayadConvenience?.toFixed(2) }}
                        </td>
                        <td>
                            <span class="badge badge-sm bg-gradient-info">
                                Php {{ transaction.totalAmountDue?.toFixed(2) }}
                            </span>
                        </td>
                        <td>
                            Php {{ transaction.standardConvenience?.toFixed(2) }}
                        </td>
                        <td>
                            <span class="badge badge-sm bg-gradient-info">
                                Php {{ transaction.totalPaid?.toFixed(2) }}
                            </span>
                        </td>
                        <td v-if="isMasterDealer">
                            Php {{ (transaction.sfSharing || 0).toFixed(2) }}
                        </td>
                        <td v-if="isMasterDealer">
                            <span class="badge badge-sm bg-gradient-success">
                                Php {{ ((transaction.standardConvenience || 0) + (transaction.sfSharing || 0)).toFixed(2) }}
                            </span>
                        </td>
                        <td v-if="isMasterDealer">
                            {{ transaction.rateDealer }}%
                        </td>
                        <td v-if="isMasterDealer">
                            {{ transaction.rateRetailer }}%
                        </td>
                        <td v-if="isMasterDealer">
                            {{ transaction.rateRetailerUser }}%
                        </td>
                        <td v-if="isMasterDealer">
                            Php {{ transaction.amtDealer?.toFixed(2) }}
                        </td>
                        <td>
                            Php {{ transaction.amtRetailer?.toFixed(2) }}
                        </td>
                        <td>
                            Php {{ transaction.amtRetailerUser?.toFixed(2) }}
                        </td>
                        <td>
                            <span class="badge badge-sm bg-gradient-info">
                                Php {{ transaction.totalWalletDeducted?.toFixed(2) }}
                            </span>
                        </td>
                        <td>
                            <span class="badge badge-sm"
                                  :class="statusConfig[transaction.status]?.class || 'bg-gradient-info'">
                                {{ statusConfig[transaction.status]?.text || transaction.status }}
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="paginate-div d-flex align-items-end mt-3 me-3">
            <vue-awesome-paginate class="ms-auto custom-pagination" :max-pages-shown="5"
                :total-items="filteredTransactions.length" :items-per-page="itemPerPage" :on-click="onPageChanged"
                v-model="currentPage" />
        </div>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
import noDataJSON from "./../../../assets/no-data.json";
import searchingJSON from "./../../../assets/searching.json";

export default {
    data() {
        return {
            noDataJSON,
            searchingJSON,
            itemPerPage: 10,
            pageItems: [],
            filters: {
                dateRange: [],
                referenceNumber: '',
                dealer: '',
                retailer: '',
                retailerUser: '',
                category: '',
                billerName: '',
                amount: '',
                bayadConvenience: '',
                totalAmountDue: '',
                standardConvenience: '',
                totalPaid: '',
                rateDealer: '',
                rateRetailer: '',
                rateRetailerUser: '',
                amtDealer: '',
                amtRetailer: '',
                amtRetailerUser: '',
                totalWalletDeducted: '',
                status: '',
            },
            statusConfig: {
                'PAYMENT_POSTED': { text: 'SUCCESS', class: 'bg-gradient-success' },
                'PENDING': { class: 'bg-gradient-warning' },
                'FAILED': { class: 'bg-gradient-danger' },
            },
        };
    },
    computed: {
        ...mapGetters({
            user: 'adminController/admin',
        }),
        ...mapState({
            currentPage: (state) => state.retailerController.bayadTransactionsCurrentPage,
            bayadTransactions: (state) => state.retailerController.bayadTransactions,
            loading: (state) => state.retailerController.bayadTransactionsLoading,
        }),
        isMasterDealer() {
            return this.user.role === 'admin';
        },
        filteredTransactions() {
            return this.bayadTransactions.filter((tx) => {
                const {
                    referenceNumber,
                    dealer,
                    retailer,
                    retailerUser,
                    category,
                    billerName,
                    amount,
                    bayadConvenience,
                    totalAmountDue,
                    standardConvenience,
                    totalPaid,
                    rateDealer,
                    rateRetailer,
                    rateRetailerUser,
                    amtDealer,
                    amtRetailer,
                    amtRetailerUser,
                    totalWalletDeducted,
                    dateRange,
                    status,
                } = this.filters;

                const inRange =
                    Array.isArray(dateRange) &&
                        dateRange.length === 2 &&
                        dateRange[0] &&
                        dateRange[1]
                        ? new Date(tx.date) >= new Date(dateRange[0]) &&
                        new Date(tx.date) <= new Date(dateRange[1])
                        : true;

                const displayStatus = tx.status === 'PAYMENT_POSTED' ? 'SUCCESS' : tx.status || '';

                return (
                    (!referenceNumber || tx.referenceNumber?.toLowerCase().includes(referenceNumber.toLowerCase())) &&
                    (!dealer || tx.dealer?.name?.toLowerCase().includes(dealer.toLowerCase())) &&
                    (!retailer || tx.retailer?.name?.toLowerCase().includes(retailer.toLowerCase())) &&
                    (!retailerUser || tx.retailerUser?.name?.toLowerCase().includes(retailerUser.toLowerCase())) &&
                    (!category || tx.categoryOfBillers?.toLowerCase().includes(category.toLowerCase())) &&
                    (!billerName || tx.nameOfBiller?.toLowerCase().includes(billerName.toLowerCase())) &&
                    (!amount || tx.amount?.toString().includes(amount)) &&
                    (!bayadConvenience || tx.bayadConvenience?.toString().includes(bayadConvenience)) &&
                    (!totalAmountDue || tx.totalAmountDue?.toString().includes(totalAmountDue)) &&
                    (!standardConvenience || tx.standardConvenience?.toString().includes(standardConvenience)) &&
                    (!totalPaid || tx.totalPaid?.toString().includes(totalPaid)) &&
                    (!rateDealer || tx.rateDealer?.toString().includes(rateDealer)) &&
                    (!rateRetailer || tx.rateRetailer?.toString().includes(rateRetailer)) &&
                    (!rateRetailerUser || tx.rateRetailerUser?.toString().includes(rateRetailerUser)) &&
                    (!amtDealer || tx.amtDealer?.toString().includes(amtDealer)) &&
                    (!amtRetailer || tx.amtRetailer?.toString().includes(amtRetailer)) &&
                    (!amtRetailerUser || tx.amtRetailerUser?.toString().includes(amtRetailerUser)) &&
                    (!totalWalletDeducted || tx.totalWalletDeducted?.toString().includes(totalWalletDeducted)) &&
                    (!status || displayStatus.toLowerCase().includes(status.toLowerCase())) &&
                    inRange
                );
            });
        },
    },
    watch: {
        filters: {
            handler() {
                this.onPageChanged(1);
            },
            deep: true,
        },
        'filters.dateRange': {
            handler(newRange) {
                if (
                    Array.isArray(newRange) &&
                    newRange.length === 2 &&
                    newRange[0] &&
                    newRange[1]
                ) {
                    const start = new Date(newRange[0]);
                    const end = new Date(newRange[1]);

                    const changed = start.getHours() !== 0 || start.getMinutes() !== 0 || end.getHours() !== 23 || end.getMinutes() !== 59;

                    if (changed) {
                        start.setHours(0, 0, 0, 0);
                        end.setHours(23, 59, 59, 999);

                        this.filters.dateRange = [start, end];
                        return;
                    }

                    this.$store.commit('retailerController/SET_BayadTransactionsFilter', {
                        ...this.$store.state.retailerController.bayadTransactionsFilter,
                        dateRange: [start, end],
                    });

                    const dateFrom = start.toISOString();
                    const dateTo = end.toISOString();

                    this.getBayadTransactions({ dateFrom, dateTo }).then(() => {
                        this.onPageChanged(1);
                    });
                }
            },
            immediate: true,
        },
        bayadTransactions() {
            this.onPageChanged(1);
        }
    },
    methods: {
        ...mapActions({
            getBayadTransactions: "retailerController/GetBayadTransactions",
        }),
        ...mapMutations({
            setCurrentPage: "retailerController/SET_BayadTransactionsCurrentPage",
        }),

        onPageChanged(page) {
            this.setCurrentPage(page);
            this.pageItems = this.filteredTransactions.slice(
                (page - 1) * this.itemPerPage,
                page * this.itemPerPage
            );
        },
    },
    async mounted() {
        const today = new Date();
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(today.getDate() - 7);

        const dateFrom = oneWeekAgo.toISOString().split("T")[0];
        const dateTo = today.toISOString().split("T")[0];

        this.filters.dateRange = [oneWeekAgo, today];

        await this.getBayadTransactions({ dateFrom, dateTo });
        this.onPageChanged(1);
    },
};
</script>

<style>
.custom-pagination .paginate-buttons {
    min-width: 35px;
    width: auto !important;
}
</style>
